import clsx from 'clsx'
import { GridLoader } from 'react-spinners'
import { Sponsor } from '../../../../core/models/db'
import { useIdentityStore, useSnackbarStore } from '../../../../core/store'
import { UploadFile } from '../../../components/drag-drop/model/UploadFile'
import { FileService } from '../../../components/drag-drop/services/file.service'

import { CContainer } from '@coreui/react-pro'

import { useContext, useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { LoaderContext } from '../../../components/loader/context/LoaderContext'

import { useTranslation } from 'react-i18next'
import { HiArrowNarrowLeft } from 'react-icons/hi'
import { BASE_ROUTE, ROUTE_NAME_ID_2, RouteName } from '../../../../core/constants/route_name'
import { useSEO, useSponsor } from '../../../../core/hooks/db/fisioteduca/useFisioteduca'
import SponsorForm from './SponsorForm'
import { Util } from '../../../../core/util/util'
import * as MessageSnackbarDefault from "../../../../core/constants/message-snackbar/msgFormDefault";

const SponsorDetail = () => {
    const { t } = useTranslation();
    const { identity } = useIdentityStore(state => state);
    const navigate = useNavigate();

    const [sponsor, setSponsor] = useState<Sponsor>(undefined);
    const [loading, setLoading] = useState(false);
    const [formHeight, setFormHeight] = useState(0);
    const formRef = useRef(null);
    const [typeAction, setTypeAction] = useState<"add" | "update">(null);

    const { handleLoading, changeStyle } = useContext(LoaderContext);
    const { addSnackbar, setMaxSnackbars } = useSnackbarStore();


    const { getSponsorById, addSponsor: add, updateSponsor: update, manageImage } = useSponsor();
    const { checkSpecificParam } = useSEO();

    const { id } = useParams();


    useEffect(() => {
        if (formRef.current) {

            console.log(formRef.current.clientHeight)


            setFormHeight(formRef.current.clientHeight);
        }
    }, [loading, sponsor]);


    /**
* Se usa al comienzo de cargar la página para rellenar la tabla
*/
    useEffect(() => {
        (async () => {



            setLoading(true);

            if (id) {
                const result = await getSponsorById(id);
                if (result && result.ok && result.item) {
                    console.log("what is the result", result)
                    let sponsor = result.item;

                    setSponsor(sponsor);
                    setTypeAction("update");

                } else {
                    console.warn("No se encontró ningún id");
                    const pagesRoutes = t('routes', { returnObjects: true });
                    let newRoute = ROUTE_NAME_ID_2({}, pagesRoutes, RouteName.sponsor);
                    navigate(`${BASE_ROUTE}${newRoute}`);
                }
            } else {
                let sponsor = new Sponsor();
                setSponsor(sponsor);
                setTypeAction("add");
            }


            setLoading(false);

        })()
    }, []);


    // const updateSponsor = async (sponsor: Sponsor,
    //     imageItem: {
    //         oldImage: string,
    //         image: string,
    //         nameImage: string
    //     }, imgAction: {
    //         imageAddList: any[]
    //         imageUpdateList: any[]
    //         deleteImageList: any[]
    //     }) => {

    //     try {
    //         setLoading(true);

    //         // if (image && image.startsWith('blob')) {
    //         //     let file = await Util.transformBlobToFile(image, "RF-" + sponsor.code + "_" + Date.now() + '.png');
    //         //     sponsor.image = await createFile(file, sponsor.id);
    //         // }

    //         const spCopy = { ...sponsor }

    //         const {
    //             oldImage = null,
    //             image = null,
    //             nameImage = null } = imageItem;


    //         if (image && image.startsWith('blob')) {
    //             const lastDotIndex = nameImage.lastIndexOf('.');

    //             // Separar el nombre del archivo antes del punto, si hay uno
    //             const name = lastDotIndex > -1 ? nameImage.slice(0, lastDotIndex) : nameImage; // Nombre del archivo
    //             const ext = lastDotIndex > -1 ? nameImage.slice(lastDotIndex) : '.png'; // Extensión del archivo

    //             // Reemplazar todos los espacios en el nombre por guiones bajos
    //             const formattedName = name.replace(/ /g, '_');

    //             // Transformar el blob en archivo usando el nombre formateado y la extensión correcta
    //             let file = await Util.transformBlobToFile(image, formattedName + "_" + Date.now() + ext);

    //             // Asignar la imagen al usuario
    //             spCopy.image = await createFile(file, spCopy.id);

    //         }

    //         // Si la imagen se ha subido correctamente, eliminar la anterior
    //         if (oldImage) {
    //             await FileService.delete(oldImage);
    //         }


    //         spCopy.imgAction = imgAction;


    //         const result = await update(spCopy);
    //         if (result.ok) {
    //             setSponsor(result.item);
    //         }
    //     } catch (error) {
    //         console.error('Error al actualizar la empresa', error);
    //     } finally {
    //         setLoading(false);
    //     }
    // }

    const updateSponsor = async (
        sponsor: Sponsor,
        imageItem: {
            oldImage: string;
            image: string;
            nameImage: string;
        },
        imgAction: {
            imageAddList: any[];
            imageUpdateList: any[];
            deleteImageList: any[];
        }
    ) => {
        try {
            setLoading(true);

            const spCopy = { ...sponsor };

            const { oldImage = null, image = null, nameImage = null } = imageItem;

            // Procesar la imagen principal del sponsor (si es un blob)
            if (image && image.startsWith("blob")) {
                const lastDotIndex = nameImage.lastIndexOf(".");

                // Separar el nombre del archivo antes del punto
                // const name = lastDotIndex > -1 ? nameImage.slice(0, lastDotIndex) : nameImage;
                const name = Date.now() + "_" + Math.random().toString(36).substring(7);
                const ext = lastDotIndex > -1 ? nameImage.slice(lastDotIndex) : ".png";

                // Formatear el nombre del archivo
                const formattedName = name.replace(/ /g, "_");

                // Transformar el blob en archivo
                const file = await Util.transformBlobToFile(
                    image,
                    `${formattedName}_${Date.now()}${ext}`
                );

                // Subir la nueva imagen
                spCopy.image = await createFile(file, spCopy.id);
            }

            // Si la imagen principal se ha subido correctamente, eliminar la anterior
            if (oldImage) {
                await FileService.delete(oldImage);
            }

            // Procesar las imágenes en imageAddList
            if (imgAction?.imageAddList?.length > 0) {
                for (const img of imgAction.imageAddList) {
                    if (img.url && img.url.startsWith("blob")) {
                        const lastDotIndex = img.name.lastIndexOf(".");
                        // const name = lastDotIndex > -1 ? img.name.slice(0, lastDotIndex) : img.name;
                        const name = Date.now() + "_" + Math.random().toString(36).substring(7);
                        const ext = lastDotIndex > -1 ? img.name.slice(lastDotIndex) : ".png";
                        const formattedName = name.replace(/ /g, "_");

                        const file = await Util.transformBlobToFile(
                            img.url,
                            `${formattedName}_${Date.now()}${ext}`
                        );

                        img.url = await createFile(file, sponsor.id); // Actualizar la URL de la nueva imagen
                        img.idSponsorFk = sponsor.id; // Asignar el ID del sponsor
                    }
                }
            }

            // Procesar las imágenes en imageUpdateList
            if (imgAction?.imageUpdateList?.length > 0) {
                for (const img of imgAction.imageUpdateList) {
                    if (img.url && img.url.startsWith("blob")) {
                        const lastDotIndex = img.name.lastIndexOf(".");
                        // const name = lastDotIndex > -1 ? img.name.slice(0, lastDotIndex) : img.name;
                        const name = Date.now() + "_" + Math.random().toString(36).substring(7);
                        const ext = lastDotIndex > -1 ? img.name.slice(lastDotIndex) : ".png";
                        const formattedName = name.replace(/ /g, "_");

                        const file = await Util.transformBlobToFile(
                            img.url,
                            `${formattedName}_${Date.now()}${ext}`
                        );

                        img.url = await createFile(file, sponsor.id); // Actualizar la URL de la imagen
                    }
                }
            }

            // No es necesario procesar las imágenes en deleteImageList, ya tienen sus URLs

            // Actualizar el sponsor con los cambios realizados
            const result = await update(spCopy);


            if (result.ok) {
                const updatedSponsor = result.item;

                // Llamar a la API para manejar las imágenes
                const manageResult = await manageImage(
                    imgAction?.imageAddList || [],
                    imgAction?.imageUpdateList || [],
                    imgAction?.deleteImageList || []
                );

                if (manageResult?.ok) {
                    // Inicializar la lista con las imágenes actuales
                    let list = [...updatedSponsor.sponsorImages];

                    // Agregar imágenes nuevas sin duplicados
                    if (manageResult?.item.addedImages?.length > 0) {
                        const newImages = manageResult.item.addedImages.filter(
                            (newImg) => !list.some((img) => img.id === newImg.id)
                        );
                        list = [...list, ...newImages];
                    }

                    // Actualizar imágenes existentes
                    if (manageResult?.item.updatedImages?.length > 0) {
                        const updatedImages = manageResult.item.updatedImages;
                        list = list.map((img) =>
                            updatedImages.some((updatedImg) => updatedImg.id === img.id)
                                ? updatedImages.find((updatedImg) => updatedImg.id === img.id)
                                : img
                        );
                    }

                    // Eliminar imágenes eliminadas
                    if (manageResult?.item.deletedImages?.length > 0) {
                        const deletedIds = manageResult.item.deletedImages.map((img) => img.id);
                        list = list.filter((img) => !deletedIds.includes(img.id));
                        updatedSponsor.sponsorImages = updatedSponsor.sponsorImages.filter(
                            (img) => !deletedIds.includes(img.id)
                        );
                    }

                    // Actualizar el listado de imágenes del sponsor actualizado
                    updatedSponsor.sponsorImages = list;

                    console.log("Lista final de imágenes:", list);
                } else {
                    console.error("Error al gestionar imágenes");
                }

                console.log("Sponsor actualizado:", updatedSponsor);

                setSponsor(updatedSponsor);
                addSnackbar(MessageSnackbarDefault.successEditDefault);
            }

        } catch (error) {
            console.error("Error al actualizar el sponsor", error);
            addSnackbar(MessageSnackbarDefault.errorDefault);

        } finally {
            setLoading(false);
        }
    };


    // const addSponsor = async (sponsor: Sponsor,
    //     imageItem: {
    //         oldImage: string,
    //         image: string,
    //         nameImage: string
    //     }, imgAction: {
    //         imageAddList: any[]
    //         imageUpdateList: any[]
    //         deleteImageList: any[]
    //     }) => {

    //     try {

    //         setLoading(true);

    //         const {
    //             oldImage = null,
    //             image = null,
    //             nameImage = null } = imageItem;

    //         if (image && image.startsWith('blob')) {
    //             let file = await Util.transformBlobToFile(image, sponsor.code + "_" + Date.now() + '.png');
    //             sponsor.image = await createFile(file, sponsor.id);
    //         }


    //         sponsor.imgAction = imgAction;
    //         const result = await add(sponsor);
    //         if (result.ok) {





    //             setSponsor(result.item);
    //         }
    //     } catch (error) {
    //         console.error('Error al actualizar la empresa', error);
    //     } finally {
    //         setLoading(false);
    //     }
    // }

    // const addSponsor = async (
    //     sponsor: Sponsor,
    //     imageItem: {
    //         oldImage: string;
    //         image: string;
    //         nameImage: string;
    //     },
    //     imgAction: {
    //         imageAddList: any[];
    //         imageUpdateList: any[];
    //         deleteImageList: any[];
    //     }
    // ) => {
    //     try {
    //         setLoading(true);

    //         const { oldImage = null, image = null, nameImage = null } = imageItem;

    //         // Manejar la imagen principal del sponsor (si es un blob)
    //         if (image && image.startsWith("blob")) {
    //             const file = await Util.transformBlobToFile(
    //                 image,
    //                 `${sponsor.code}_${Date.now()}.png`
    //             );
    //             sponsor.image = await createFile(file, sponsor.id);
    //         }

    //         // Crear el sponsor
    //         const result = await add(sponsor);
    //         if (result.ok) {
    //             const createdSponsor = result.item;


    //             if (imgAction?.imageAddList.length > 0) {
    //                 for (const img of imgAction.imageAddList) {
    //                     console.log("que es img", img);
    //                     if (img.url && img.url.startsWith("blob")) {
    //                         // Agregar logs para depuración
    //                         console.log("Procesando imagen:", img);

    //                         const file = await Util.transformBlobToFile(
    //                             img.image,
    //                             `${sponsor.code}_${Date.now()}.png`
    //                         );

    //                         img.url = await createFile(file, createdSponsor?.id); // Actualizar la URL tras crear el archivo
    //                         img.idSponsorFk = createdSponsor?.id; // Asignar el ID del sponsor
    //                         delete img.image; // Limpiar el blob, no se necesita para la API

    //                         // Log para verificar cambios en el objeto img
    //                         console.log("Imagen procesada:", img);
    //                     }
    //                 }
    //             }

    //             // Llamar a `manageImage` para procesar las listas de imágenes
    //             const manageResult = await manageImage(
    //                 imgAction.imageAddList,
    //                 imgAction.imageUpdateList,
    //                 imgAction.deleteImageList
    //             );


    //             if (manageResult?.ok) {
    //                 if (manageResult?.item.addedImages) {
    //                     createdSponsor.sponsorImages = createdSponsor.sponsorImages.concat(manageResult?.item.addedImages);
    //                 }
    //                 if (manageResult?.item.updatedImages) {
    //                     createdSponsor.sponsorImages = createdSponsor.sponsorImages.concat(manageResult?.item.updatedImages);
    //                 }
    //                 if (manageResult?.item.deletedImages) {
    //                     createdSponsor.sponsorImages = createdSponsor.sponsorImages.filter(
    //                         (img) => !manageResult?.item.deletedImages.includes(img.id)
    //                     );
    //                 }
    //                 console.log("Imágenes gestionadas correctamente");
    //             } else {
    //                 console.error("Error al gestionar imágenes");
    //             }

    //             setTypeAction("update");

    //             setSponsor(createdSponsor);
    //         } else {
    //             console.error("Error al crear el sponsor");
    //         }
    //     } catch (error) {
    //         console.error("Error al agregar el sponsor", error);
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    /**
  * Función para agregar un nuevo Sponsor
  */
    const addSponsor = async (
        sponsor: Sponsor,
        imageItem: {
            oldImage: string;
            image: string;
            nameImage: string;
        },
        imgAction: {
            imageAddList: any[];
            imageUpdateList: any[];
            deleteImageList: any[];
        }
    ) => {
        try {
            setLoading(true);

            // 1. Crear una copia del Sponsor sin la imagen principal y sin las imágenes adicionales
            const sponsorToCreate = { ...sponsor };
            delete sponsorToCreate.image;

            // 2. Crear el Sponsor sin imágenes
            const createResult = await add(sponsorToCreate);
            if (!createResult.ok) {
                throw new Error("Error al crear el Sponsor");
            }

            const createdSponsor = createResult.item;
            setTypeAction("update");
            setSponsor(createdSponsor);

            const newSponsorId = createdSponsor.id;

            // 3. Subir la imagen principal si existe y es un blob
            let mainImagePath = createdSponsor.image;
            if (imageItem.image && imageItem.image.startsWith("blob:")) {
                // const fileName = `sponsor_main_${Date.now()}.png`;
                // const file = await Util.transformBlobToFile(imageItem.image, fileName);
                // mainImagePath = await createFile(file, newSponsorId);
                const lastDotIndex = imageItem.nameImage.lastIndexOf(".");
                // const name = lastDotIndex > -1 ? imageItem.nameImage.slice(0, lastDotIndex) : imageItem.nameImage;
                const name = Date.now() + "_" + Math.random().toString(36).substring(7);
                const ext = lastDotIndex > -1 ? imageItem.nameImage.slice(lastDotIndex) : ".png";
                const formattedName = name.replace(/ /g, "_");
                let file = await Util.transformBlobToFile(
                    imageItem.image,
                    formattedName + "_" + Date.now() + ext
                );
                mainImagePath = await createFile(file, newSponsorId);

            }

            // 4. Subir las imágenes adicionales en imageAddList
            if (imgAction?.imageAddList?.length > 0) {
                for (const img of imgAction.imageAddList) {
                    if (img.url && img.url.startsWith("blob")) {
                        const lastDotIndex = img.name.lastIndexOf(".");
                        // const name = lastDotIndex > -1 ? img.name.slice(0, lastDotIndex) : img.name;
                        const name = Date.now() + "_" + Math.random().toString(36).substring(7);
                        const ext = lastDotIndex > -1 ? img.name.slice(lastDotIndex) : ".png";
                        const formattedName = name.replace(/ /g, "_");

                        const file = await Util.transformBlobToFile(
                            img.url,
                            `${formattedName}_${Date.now()}${ext}`
                        );

                        img.url = await createFile(file, newSponsorId); // Actualizar la URL de la nueva imagen
                        img.idSponsorFk = newSponsorId; // Asignar el ID del sponsor
                    }
                }
            }

            // 5. Manejar las imágenes adicionales utilizando manageImage
            const manageResult = await manageImage(
                imgAction?.imageAddList || [],
                imgAction?.imageUpdateList || [],
                imgAction?.deleteImageList || []
            );

            if (manageResult?.ok) {
                let list = [...createdSponsor.sponsorImages];

                // Agregar imágenes nuevas sin duplicados
                if (manageResult?.item.addedImages?.length > 0) {
                    const newImages = manageResult.item.addedImages.filter(
                        (newImg) => !list.some((img) => img.id === newImg.id)
                    );
                    list = [...list, ...newImages];
                }

                // Actualizar imágenes existentes
                if (manageResult?.item.updatedImages?.length > 0) {
                    const updatedImages = manageResult.item.updatedImages;
                    list = list.map((img) =>
                        updatedImages.some((updatedImg) => updatedImg.id === img.id)
                            ? updatedImages.find((updatedImg) => updatedImg.id === img.id)
                            : img
                    );
                }

                // Eliminar imágenes eliminadas
                if (manageResult?.item.deletedImages?.length > 0) {
                    const deletedIds = manageResult.item.deletedImages.map((img) => img.id);
                    list = list.filter((img) => !deletedIds.includes(img.id));
                    createdSponsor.sponsorImages = createdSponsor.sponsorImages.filter(
                        (img) => !deletedIds.includes(img.id)
                    );
                }

                // Actualizar el listado de imágenes del Sponsor creado
                createdSponsor.sponsorImages = list;

                console.log("Lista final de imágenes:", list);
            } else {
                console.error("Error al gestionar imágenes");
            }

            // 6. Actualizar el Sponsor con la ruta de la imagen principal
            const updatedSponsor = {
                ...createdSponsor,
                image: mainImagePath,
            };

            const {
                seo,
                sponsorImages,
                ...rest } = updatedSponsor;
            const updateResult = await update(rest);
            if (updateResult.ok) {
                setSponsor(updateResult.item);

                addSnackbar(MessageSnackbarDefault.successAddDefault);
            } else {
                throw new Error("Error al actualizar el Sponsor con la imagen principal");
            }
        } catch (error) {
            console.error("Error al agregar el Sponsor", error);
            addSnackbar(MessageSnackbarDefault.errorDefault);
        } finally {
            setLoading(false);
        }
    };


    const createFile = async (file: any, id) => {
        try {
            const { data } = await FileService.add(new UploadFile(file, ["images", 'sponsor', id]), null);

            if (data.ok) {
                const pathRelative = `/${data.item[0].destination}/${data.item[0].filename}`;
                return pathRelative;
            } else {
                return undefined;
            }
        } catch (e) {
            throw e;
        }
    };

    const checkCode = async (id, value) => {
        try {
            // setLoading(true);
            if (value !== "") {
                value = `RF-${value}`?.trim();
            }
            // const result = await checkSpecificParamsSponsor(id, value?.toUpperCase(), "code");
            // console.log('result', result);


            // return result?.ok && result?.exists;

        } catch (error) {
            console.error('Error al verificar el código de la empresa', error);
        } finally {

        }
    };

    const handleRecord = (value: Sponsor, imageItem: {
        oldImage: string,
        image: string,
        nameImage: string,
    }, imgAction: {
        imageAddList: any[]
        imageUpdateList: any[]
        deleteImageList: any[]
    }) => {
        console.log("value", value, typeAction);
        if (typeAction === "add" && !value?.id) {
            addSponsor(value, imageItem, imgAction);
        } else if (typeAction === "update" && value?.id !== undefined) {
            updateSponsor(value, imageItem, imgAction);
        } else {
            // mostrar mensaje error y mandarlo al login
        }
    }

    return (

        <CContainer style={{ display: 'flex', flexDirection: 'column' }}>
            <div className="w-full justify-between items-center flex  pt-4 pb-5">
                <div className="flex flex-col">
                    <div className="flex items-center hover:underline cursor-pointer" style={{ marginBottom: 20 }} onClick={() => {
                        const pagesRoutes = t('routes', { returnObjects: true });
                        let newRoute = ROUTE_NAME_ID_2({}, pagesRoutes, RouteName.sponsor);
                        navigate(`${BASE_ROUTE}${newRoute}`);
                    }}>
                        <HiArrowNarrowLeft size={20} className="mr-1" />
                        {t('screens.sponsor.labelGoBack')}
                    </div>

                    <span className="text-4xl" style={{ fontWeight: 500 }}>{t('screens.sponsor.title')}</span>
                    <span className="small text-medium-emphasis" >{typeAction === "add" ? t('screens.sponsor.labelCreate') : t('screens.sponsor.labelDetail')}</span>
                </div>
            </div>




            <div className='w-full flex justify-center mb-10'>
                <div className="w-full flex justify-center gap-4 flex-col xl:flex-row ">

                    {/* Primera columna */}
                    {/* xl:w-[70%] */}
                    <div className={clsx(`flex flex-col w-full justify-center items-center`, {
                        'xl:w-[100%]': sponsor?.id,
                    })}>
                        <div className={clsx(`bg-white block p-4 md:p-7 shadow-md md:rounded-lg w-full md:w-[70%] `, {})}>

                            <div className="text-2xl font-medium mb-4">{t('screens.sponsor.subtitle_1')}</div>
                            <div className="w-full flex flex-col md:flex-row  justify-center md:gap-4">



                                {loading && (
                                    <div className="w-full flex flex-col justify-center items-center" style={{ height: 547 }}>
                                        <GridLoader color='#3d4f65' size={25} speedMultiplier={0.7} />
                                    </div>
                                )}

                                {!loading && sponsor && (
                                    <div ref={formRef} className='p-0'>
                                        <SponsorForm
                                            initialSponsor={sponsor}
                                            onSubmit={(sponsor: Sponsor, imageItem: {
                                                oldImage: string,
                                                image: string,
                                                nameImage: string
                                            }, imgAction: {
                                                imageAddList: any[]
                                                imageUpdateList: any[]
                                                deleteImageList: any[]
                                            }) => {
                                                console.log("Sponsor guardado:", sponsor);
                                                console.log("imageItem", imageItem);
                                                handleRecord(sponsor, imageItem, imgAction);

                                            }}

                                            checkSponsorSlug={async (id, value) => {
                                                const result = await checkSpecificParam(id, value, "slug");
                                                return result;

                                            }}
                                        />

                                    </div>
                                )}

                            </div>

                        </div >
                    </div>




                </div>
            </div >
            {/* <UserForSponsorPageModal /> */}

        </CContainer>

    )
}

export default SponsorDetail